interface ButtonProps {
    onClick?: () => void;
    className: string;
    children: React.ReactNode;
}

export const Button: React.FC<ButtonProps> = ({ onClick, className, children }) => {
    return (
        <button 
            onClick={onClick}
            className={className}
        >
            {children}
        </button>
    );
};